<ng-container *transloco="let t">
    <div class="bg-dialog">
        <div class="p-16 px-4 sm:px-16  basis-1/3 h-[750px] pane"
            [ngStyle]="{'background': 'url(' + backgroundImageSource + ')'}">

            <ng-container *ngIf="videoPlaying">
                <video class="w-full h-[549px]" controls #videoPlayer controlsList="nodownload" autoplay
                    (ended)="videoEnded()"
                    style="right: 0;bottom: 0;min-width: 100%;min-height: 20%;height: 100%;width: 100%; z-index: 9500;">
                    <source src="assets/videos/SimonLagertEin.mp4" type="video/mp4">
                    Your browser does not support the video.
                </video>
            </ng-container>

            <div class="flex flex-col ml-4" *ngIf="!videoPlaying">
                <!-- Arrow-->
                <div class="mt-62">
                    <div class="flex flex-row">
                        <hr class="bg-primary w-24">
                        <!-- Pre Title-->
                        <p class="mt-5 ml-5 text-primary font-semibold">{{t(pretitle)}}</p>
                    </div>
                </div>
                <!-- Title-->
                <div class="mt-2 ml-4 font-medium text-3xl">{{t(title)}}</div>

                <div class="mt-36 place-self-center">
                    <img src="assets/icons/play_button.svg" class="w-24 filter-white" (click)="playVideo()">
                </div>
            </div>
        </div>
    </div>
</ng-container>
